<template>
  <div class="w-9/12 m-auto text-gray-90 mt-20">
    <h2 class="text-5xl font-medium p-2 uppercase flex flex-col items-center justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="animate__animated animate__swing animate__delay-1s h-20 flex-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
      </svg>
      <span>Page under <br>construction</span>
    </h2>
    <p class="text-lg mt-2">We're still brewing the best concontion for you.<br>It will take us a few  more time. Thank you for your patience.
    <span class="block mt-4">Go back to <router-link class="text-blue-500" to="/">homepage</router-link> instead.</span></p>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed } from 'vue';

export default {
  setup(){
    
    const store = useStore();
    const auth = computed(()=> store.getters.auth );

    return{
      auth
    }
  }
}
</script>

<style>

</style>